const appUrl =
  process.env.REACT_APP_ROOFER_APP_URL ||
  'https://develop-ui-roofer-area.meindach.de';

export default {
  apiUrl: process.env.REACT_APP_B2B_URL || 'http://localhost:8081',
  rooferDirectSignIn: `${appUrl}`,
  appUrl: process.env.REACT_APP_ROOFER_REGISTRATION_URL || '',
};
